/** Permission lattice shared by REST, WebSocket and UI. */
export const ROLE_RANK = { none: 0, viewer: 1, commenter: 2, editor: 3, owner: 4 } as const;
export type Role = keyof typeof ROLE_RANK;
export type BoardAction = "view" | "comment" | "edit" | "manage";
const ACTION_RANK: Record<BoardAction, number> = { view: 1, comment: 2, edit: 3, manage: 4 };
export const can = (role: Role, action: BoardAction): boolean => ROLE_RANK[role] >= ACTION_RANK[action];

export const WORKSPACE_ROLES = ["owner", "admin", "member"] as const;
export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];
export const GUEST_ROLES = ["viewer", "commenter", "editor"] as const;
export type GuestRole = (typeof GUEST_ROLES)[number];
